export enum TaskStatus {
  ALL = "ALL",
  ENDED = "ENDED",
  ACTIVE = "ACTIVE",
  NOT_STARTED = "NOT_STARTED",
  SUSPENDED = "SUSPENDED",
}
